<span
    class="browse-button"
    [attr.data-uiid]="dataUiid + 'browse-button'"
    (click)="openFileSelect()"
    >{{ text ?? ('controls.effBrowseFilesButton.browse' | transloco) }}</span
>

<input
    type="file"
    id="fileUpload"
    [accept]="allowedFileExtensions"
    [multiple]="true"
    [hidden]="true"
    [attr.data-uiid]="dataUiid + '-file-input'"
    (change)="updateFiles()"
    #fileInput
/>
